import { parseFlaggedLinkUrl } from "./openAppFlag";

const ANDROID_WEBVIEW_PATTERN = /android.*; wv\)/i;

// Instagram, Threads (its user agent says "Barcelona"), Facebook, Messenger.
const META_IN_APP_BROWSER_PATTERN = /instagram|barcelona|fban|fbav|fb_iab/i;

// Same rule as the Android config form. It also blocks ";", which would let a
// bad package name add its own fields to the intent.
const PACKAGE_NAME_PATTERN =
  /^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)+$/;

/**
 * Workaround for Meta's in-app browsers on Android. They open every link in
 * their own WebView, so App Links never open the installed app. An intent: URL
 * started by the page does open it, after Meta's "leaving the app" prompt.
 *
 * Meta only: other WebViews show an ERR_UNKNOWN_URL_SCHEME error page instead.
 * Tested on a device: Instagram on 2026-10-01, Threads on 2026-10-08.
 *
 * The intent and its fallback use the link without the flag. Instagram ignores
 * the fallback. A WebView that follows it runs the normal flow, which records
 * the click and opens the Play Store with the click id. Without a fallback, a
 * missing app could open the Play Store with no click id.
 */
export function buildAppIntentUrl(
  pageUrl: string,
  userAgent: string,
  packageName: string | null | undefined
): string | null {
  if (
    !ANDROID_WEBVIEW_PATTERN.test(userAgent) ||
    !META_IN_APP_BROWSER_PATTERN.test(userAgent)
  ) {
    return null;
  }
  if (!packageName || !PACKAGE_NAME_PATTERN.test(packageName)) return null;

  const linkUrl = parseFlaggedLinkUrl(pageUrl);
  if (!linkUrl) return null;

  const scheme = linkUrl.protocol.slice(0, -1);

  return (
    `intent://${linkUrl.host}${linkUrl.pathname}${linkUrl.search}` +
    `#Intent;scheme=${scheme};package=${packageName};` +
    `S.browser_fallback_url=${encodeURIComponent(linkUrl.href)};end`
  );
}
